import { Component, OnInit } from '@angular/core';
import { ModalExtended} from 'ngx-dynamic-modal';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {VnaClientService} from '../../service/vna-client.service';
import {AlertaService} from '../../../../shared/services/alerta.service';

@Component({
  selector: 'app-edit-vna-client-modal',
  templateUrl: './edit-vna-client-modal.component.html',
  styleUrls: ['./edit-vna-client-modal.component.scss']
})
export class EditVnaClientModalComponent extends ModalExtended implements OnInit {

  data:any;
  formSearch:FormGroup;

  constructor(private clientHandler:VnaClientService,
              private alerta:AlertaService) {
    super();

    this.formSearch=new FormGroup(
        {
        'username':new FormControl('',Validators.required),
        'active':new FormControl('0',Validators.required),
        'allowed_ips':new FormControl('')
        })
  }

  ngOnInit() {
      if(this.data.element){
          this.formSearch.controls['username'].setValue(this.data.element.username);
          this.formSearch.controls['active'].setValue(this.data.element.active);
          this.formSearch.controls['allowed_ips'].setValue(this.data.element.allowed_ips);
      }
  }

  saveData(data){
      if(data.valid){
          let client=data.value;
          this.clientHandler.postClient(client)
              .subscribe(result=>{
                  this.onExit({edit:false,element:result.data});
              }, error => {
                  //console.log(error);
                  this.alerta.addAlert('error','Something went wrong')
              }, () => {
                  this.alerta.addAlert('success','Client Saved Succesfully!!')
              })
      }
  }

  updateData(data){
      if(data.valid) {
          let client = data.value;
          client['pk']=this.data.element.pk;
          this.clientHandler.putClient(client)
              .subscribe(result => {
                  this.onExit({edit:true,element:result.data});
              }, error => {
                  //console.log(error);
                  this.alerta.addAlert('error','Something went wrong')
              }, () => {
                  this.alerta.addAlert('success','Client Updated Succesfully!!')
              })
      }
  }

  onExit(data=null) {
        this.applyCallback(data);
        this.close();
  }
}


// WEBPACK FOOTER //
// /var/www/backend/src/app/client/management/modals/edit-vna-client-modal/edit-vna-client-modal.component.ts